import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Modules/Base/Components/BaseModal/BaseModal';
import SearchMedicamentRecord from './SearchMedicamentRecord';
import { Size } from '../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	patientId?: string;
}

const SearchMedicamentRecordModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.medicationRecord' size={Size.FULLSCREEN}>
			<SearchMedicamentRecord patientId={props.patientId} />
		</BaseModal>
	);
};

export default SearchMedicamentRecordModal;
